var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('div',{staticClass:"wrapper"},[_c('div',[_c('span',[_vm._v("把记账本推荐给朋友")])]),_c('div',[_c('span',[_vm._v("点个start支持哦")])]),_c('div',[_c('span',[_vm._v("后续展望 将使用Vue3与Vite进行重构")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }